<template>
  <div class="press">
    <div class="campus">电商管理
      <span>></span>
      课程管理
      <span>></span>
      秒杀课程
    </div>

    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">全部课程</div>

          <div class="tableStyle">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column label="课程封面" min-width="70">
                <template slot-scope="scope">
                  <img class="tableImg" :src="scope.row.coverUrl" />
                </template>
              </el-table-column>
              <el-table-column prop="name" label="课程名称" align="center">
              </el-table-column>
              <el-table-column prop="seckillPrice" label="秒杀价" align="center">
              </el-table-column>
              <el-table-column prop="beginTime" label="开始时间" align="center">

              </el-table-column>
              <el-table-column prop="endTime" label="结束时间" align="center">
                <template slot-scope="scope">
                  {{scope.row.endTime}}
                </template>
              </el-table-column>
              <el-table-column prop="typeStr" label="课程类型" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="deletkill(scope.row)">删除</el-button>
                  <el-button type="text" @click="editkill(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dz-flex dz-flex-justify-end mt-12">
            <el-pagination background @size-change="getcourselist" @current-change="getcourselist" :current-page.sync="page" :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
          <el-dialog title="添加秒杀" :visible.sync="secondkillDialog" width="50%">
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item label="开始时间">
                <el-col :span="11">
                  <el-date-picker v-model="form.date1" type="datetime" value-format="yyyy-MM-dd hh:mm:ss" placeholder="选择日期时间"></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-col :span="11">
                  <el-date-picker v-model="form.date2" type="datetime" value-format="yyyy-MM-dd hh:mm:ss" placeholder="选择日期时间"></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="课程价格:" prop="rises">
                <el-input v-model="form.skillprice" placeholder="请输入价格" onkeyup="this.value=this.value.replace(/[^0-9,.]/g,'')"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="secondkillDialog = false">取 消</el-button>
              <el-button type="primary" @click="submitkill()">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'press',
  data() {
    return {
      tableData: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,
      chooseClass: [],
      secondkillDialog: false,
      killId: '',
      form: {
        date1: '',
        date2: '',
        skillprice: '',
      },
    };
  },
  created() {
    this.getcourselist();
  },
  methods: {
    //查询列表
    getcourselist() {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/seckill?'+'page='+this.page+'&pageSize='+this.pageSize,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'sas');
          if (result.data.code === 0) {
            this.tableData = result.data.data;
            this.total = result.data.size;
            for(let i = 0;i<this.tableData.length;i++){
              let str = this.tableData[i].beginTime;
              var dateee = new Date(str).toJSON();
              var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
              this.tableData[i].beginTime = date;

              let strs = this.tableData[i].endTime;
              var dateee = new Date(strs).toJSON();
              var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
              this.tableData[i].endTime = date;
            }
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('查询失败：' + err);
        });
    },
    //删除秒杀
    deletkill(row) {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/seckill/' + row.id + '/del',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'sas');
          if (result.data.code === 0) {
            this.getcourselist();
          }
        })
        .catch((err) => {
          this.$message.err('删除失败：' + err);
        });
    },
    editkill(row) {
      console.log(row);
      this.killId = row.id;
      this.secondkillDialog = true;
      this.form.date1 = row.beginTime;
      this.form.date2 = row.endTime;
      this.form.skillprice = row.seckillPrice;
      console.log(row, 'ss');
    },
    submitkill() {
        console.log(this.form.date1,this.form.date2);
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/seckill/' + this.killId + '/upd',
        method: 'POST',
        data: {
          beginTime: this.form.date1,
          endTime: this.form.date2,
          seckillPrice: this.form.skillprice,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'sas');
          if (result.data.code === 0) {
            this.getcourselist();
            this.secondkillDialog = false
            this.$message.success('修改成功！');
          }
        })
        .catch((err) => {
          this.$message.error('修改失败：' + err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.press {
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 135px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar-uploader {
    img {
      width: 120px;
      height: 120px;
    }
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
}
</style>
